import React, { useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PDFViewer = ({ uploadedManual }) => {
  const [error, setError] = useState(null);

  // Create the default layout plugin
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handleDocumentLoadError = (err) => {
    console.error("Failed to load PDF document:", err);
    setError("Failed to load the PDF document.");
  };

  if (error) {
    return (
      <div className="w-full h-full flex items-center justify-center text-red-600">
        {error}
      </div>
    );
  }

  if (!uploadedManual?.url) {
    return (
      <div className="w-full h-full flex items-center justify-center text-gray-500">
        <p>No document selected</p>
      </div>
    );
  }

  return (
    <div
      className="w-full h-full block"
      style={{
        position: "relative",
        overflow: "hidden",
        maxWidth: "100%",
        maxHeight: "100%",
      }}
    >
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
            contain: "layout style size",
          }}
        >
          <Viewer
            fileUrl={uploadedManual.url}
            plugins={[defaultLayoutPluginInstance]}
            onDocumentLoadError={handleDocumentLoadError}
          />
        </div>
      </Worker>
    </div>
  );
};

export default PDFViewer;
